module.exports = __webpack_public_path__ + "fonts/STKBureauSans-Light.3e896552c675b2e8571de3c07b11faa6.woff";